import { environment } from '../../../environments/environment';
import { isStateModeGroup } from './state-mode.util';

/**
 * True when the connect (switching platform) integration is enabled both in the
 * build environment and on the given group. A state unit never has it.
 */
export function isConnectEnabledForGroup(group: { connectEnabled?: boolean; connectTenantId?: string; stateMode?: boolean } | null | undefined): boolean {
  return !!(environment.connectEnabled && group?.connectEnabled && group?.connectTenantId && !isStateModeGroup(group));
}
